<template>
    <div class="login-bg">
        <div class="login-main-box">
            <h3>登录</h3>
            <!-- <div class="input-box">
                <input type="text" placeholder="请输入账号" />
                <div class="input-tips">账号输入错误</div>
            </div>
            <div class="input-box">
                    <input type="text" placeholder="请输入密码" />
            </div> -->
             <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="phone">
                    <el-input v-model="ruleForm.phone" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input class="kuang_last" v-model="ruleForm.password" type="password" placeholder="请输入密码"></el-input>
                </el-form-item>
            </el-form>
            <div class="input-right-register">没有账号？去<a href="javascript:;" @click="toRegister">注册</a></a></div>
            <div class="error-tips-code" style="visibility:hidden;margin-top:.1rem;">密码输入错误</div>
            <button class="login-button" @click="submitLogin('ruleForm')" :plain="true">登录</button>
        </div>
        
    </div>

</template>

<script>
export default {
        name: 'Login',
        data () {
            var checkPhone = function(rule, value, callback){
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                } else {
                    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                    // console.log(reg.test(value));
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入正确的手机号'));
                    }
                }
            }
            return {
                ruleForm: {
                    phone: '',
                    password: '',
                },
                rules: {
                    phone: [
                        {validator: checkPhone, trigger: 'blur'}
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                }

            }
        },
        mounted(){
            this.baseUrl = window.baseUrl;
            this.config = window.config;
        },
        methods: {
            toRegister:function(){
                this.$router.push({
                    name: 'Register',
                    params: {
                    }
                });
            },
            submitLogin(formName) {
                var that = this;
                that.$refs[formName].validate((valid) => {
                if (valid) {
                    that.$http.post(that.baseUrl+that.config.login,that.$qs.stringify(that.ruleForm)).then(function(ev){
                        // console.log(ev);
                        if(ev.data.code == 100){
                            that.open2('登录成功');
                            //登陆成功后 存储用户信息
                            localStorage.user = JSON.stringify(ev.data.data);
                            localStorage.mobile = ev.data.data.mobile;
                            localStorage.token =  ev.data.data.token;
                        }else{
                            that.open4(ev.data.message);
                        }
                    }).catch(function(error){
                        console.log(error);
                    })
                } else {
                    that.open4('请检查您的输入');
                    return false;
                }
                });
            },
            //成功信息
            open2(succ_mes) {
                var that = this;
                that.$message({
                    message: succ_mes,
                    type: 'success'
                });
                //跳转到首页
                setTimeout(function(){
                    that.$router.push({path: '/Main'});
                },1500)
            },
            //错误信息
            open4(mes) {
                this.$message.error(mes);
            }
        },
        created(){

        }
    }

</script>

<style>
.el-input{ margin:0px 3%;width:96%;}
.el-form-item__error{ width: 96%; margin:0 6%;}
.el-input input{ border-radius:10px; border:1px solid #ccc; margin:0px 3%; width:94%;}
</style>


// WEBPACK FOOTER //
// src/pages/login.vue